export const MODE = {
    show: true,
    hide: false
};
export const OPEN = 'OPEN_MESSAGE_MODAL';
export const CLOSE = 'CLOSE_MESSAGE_MODAL';

// Actions for message modal
const openModal = (payload) => (dispatch) => {
    dispatch({
        type: OPEN,
        payload
    });
};

const closeModal = () => (dispatch) => {
    dispatch({
        type: CLOSE,
        payload: ''
    });
};

export default {
    openModal,
    closeModal
}
